const EVENTS = {
  FETCH_BEFORE: "frame-fetch-before",
  FETCH: "frame-fetch",
  FETCH_AFTER: "frame-fetch-after",
  ERROR: "frame-error",
  CONTENT: "frame-content",
  CONTENT_AFTER: "frame-content-after",
  TRIGGER: "frame-trigger"
};
export {
  EVENTS
};
//# sourceMappingURL=utils.js.map
